// eslint-disable-next-line import/prefer-default-export
export function transformOffers(offers) {
	return offers.map(offer => ({
		id: offer.id,
		title: offer.title,
		viewsCount: offer.viewsCount,
		applicationCount: offer.offer_applications.length,
	}));
}
